import type { PaymentStatus } from '@/types/finance'

interface PaymentStatusBadgeProps {
  status: PaymentStatus
  size?: 'sm' | 'md'
}

const statusConfig: Record<PaymentStatus, { label: string; className: string }> = {
  UNPAID: {
    label: '未繳',
    className: 'bg-red-100 text-red-800',
  },
  PAID: {
    label: '已繳',
    className: 'bg-green-100 text-green-800',
  },
  ACH_SUCCESS: {
    label: 'ACH成功',
    className: 'bg-green-100 text-green-800',
  },
  ACH_FAILED: {
    label: 'ACH失敗',
    className: 'bg-red-100 text-red-800',
  },
  MANUAL_VERIFIED: {
    label: '人工核銷',
    className: 'bg-blue-100 text-blue-800',
  },
  PARTIAL: {
    label: '部分繳納',
    className: 'bg-yellow-100 text-yellow-800',
  },
  OVERPAID: {
    label: '溢繳',
    className: 'bg-purple-100 text-purple-800',
  },
  PENDING_REVIEW: {
    label: '待審核',
    className: 'bg-gray-100 text-gray-800',
  },
}

const PaymentStatusBadge = ({ status, size = 'sm' }: PaymentStatusBadgeProps) => {
  const config = statusConfig[status] || { label: status, className: 'bg-gray-100 text-gray-800' }

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm'

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.className} ${sizeClasses}`}>
      {config.label}
    </span>
  )
}

export default PaymentStatusBadge
